import React, { useEffect, useState} from "react";
import axios from "axios";
import url from "../../services/url";
import { If } from "react-condition";
import { useHistory,useLocation} from "react-router-dom";
import {useParams} from 'react-router-dom'
import Loginimg from "../../images/Maxicus_logo.png";

function UserPasswordConfirm() {
  const [alert, setAlert] = useState("");
  const [Password,setPassword] = useState("")
  const [ConfirmPassword,setConfirmPassword] = useState("");
  const {search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [error,SetError] = useState("")
  const [Color,SetColor] = useState(true);
  const id = searchParams.get('id');
  let [PasswordError,setPasswordError] = useState("")
  const [Check,setCheck] = useState(false);

  const history = useHistory();
  const Validate=()=>{
      let PassError="";
    console.log(Password.length);
    if(Password.length < 8){
        PassError = "Length cannot be less than 8 digit"
    }
    if(Password.length >14){
        PassError = "Length cannot be greater than 14 digits"
    }
    if(PassError){
        SetError(PassError)
        setCheck(true)
        return false;
    }
    return true
  }

  const ResetPassword=async(e)=>{
      e.preventDefault();
    const isValid =  Validate();
    console.log(isValid)
    if(isValid){
    setCheck(false)
    // const response = await fetch(`http://172.17.103.25:4001/api/candidates/updateResetPassword`,{
        const response = await fetch(url("User/updateResetPassword"),{
        method: "post" ,
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id:id,
            newPassword:Password,
            confirmNewPassword:ConfirmPassword
        })
    })
    const res=await response.json()
     //console.log(response.status)
    console.log(response)
     if(response.status === 200){
         SetError(res.message)
         if(res.role !== "consultant"){
          history.push("/");
         }
         else{
          history.push("/consultant");
         }
         
         SetColor(false)
         setPassword("");
         setConfirmPassword("");
     }
     else{
        SetError("Plz Try Again..")
     }}
  }
  

  return (
    <div className="container bg-white">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img src={Loginimg} alt="Login" className="mb-1" />
                      <small className="app-name">Digital Hiring</small>
                      <hr />
                      <h1 className="h4 text-gray-900 mb-4">Update Password </h1>
                      <p style={Color ? { color:'red'} : { color:'green'} }>{error}</p>
                      {Check && <p style={{color:'red'}}>{PasswordError}</p>}
                    </div>
                    <If test={alert !== ""}>
                      <div className="alert alert-danger">{alert}</div>
                    </If>
                    <form className="user" method="post">
                      <div className="form-group">
                        <input
                          type="password"
                          value={Password}
                          className="form-control form-control-user"
                          onChange={(e)=>setPassword(e.target.value)}
                          placeholder="Enter Password..."
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          value={ConfirmPassword}
                          className="form-control form-control-user"
                          onChange={(e)=>setConfirmPassword(e.target.value)}
                          placeholder="Enter ConfirmPassword..."
                        />
                      </div>
                      <button
                        className="btn btn-primary btn-user btn-block"
                        disabled={!Password || !ConfirmPassword || Password !== ConfirmPassword}
                         onClick={ResetPassword}
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPasswordConfirm;